module.exports = __webpack_public_path__ + "img/9788958285892.b39c18a4.jpg";